import { ChakraText } from '@equip.health/ui';

const Notifications = () => <ChakraText>Notifications</ChakraText>;

export default Notifications;
